var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2672 0.71875H4.73675C4.54087 0.71875 4.4315 0.953303 4.5528 1.11343L7.81801 5.40755C7.91147 5.53046 8.09144 5.53046 8.18589 5.40755L11.4511 1.11343C11.5724 0.953303 11.463 0.71875 11.2672 0.71875Z",
    fill: "#AFB7FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSortDesc);
export default __webpack_public_path__ + "static/media/arrow-sort-desc.31f5e872161bb64355aea205bde79c7e.svg";
export { ForwardRef as ReactComponent };